import Model  from '@/util/models';
import Dapil  from './Dapil';
import Partai from './Partai';


export default class Kompetisi extends Model { 
    backend = '/frc/dashboard/'; 
       
    kompetisis(params){
        return this.api.get(this.backend + 'kompetisis', params);
    }
    
    kompetisi(params){
        return this.api.get(this.backend + 'kompetisi', params);
    }
    
    areas(params){
        return this.api.get(this.backend + 'areas', params);
    }
    
    dapils(params){
        return this.api.get(this.backend + 'dapils', params);
    }    
    
    calegs(params){
        return this.api.get(this.backend + 'calegs', params);
    } 
        
    partais(params){
      let model = new Partai();
      return model.all(params);
    }
    
    getImg(params){
        return this.api.get('/frc/image/get-img', params);
    }
    
    getThumb(params){
        return this.api.get('/frc/image/get-thumb', params);
    }
}

